import React from 'react';

const NotFoundPage = () => {
    return (
        <div>
            <section className='mx-auto'>
                <img
                    style={{ height: '550px' }}
                    className='w-100'
                    src='https://howfix.net/wp-content/uploads/2018/02/sIaRmaFSMfrw8QJIBAa8mA-article.png'
                    alt=''
                />
            </section>
        </div>
    );
};

export default NotFoundPage;